import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Row = styled.div`
  display: flex;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

const SkeletonWrapper = styled(Row)`
  overflow-x: hidden;

  @keyFrames skeletonMove {
    0% {
      background-position-x: 100%;
    }
    100% {
      background-position-x: -200%;
    }
  }
`;

const SkeletonCard = styled(Row)`
  margin-right: 10px;
  margin-bottom: 10px;
  ${props => props.expand ? `flex: 1 1 0px;` : ``}
`;

const SkeletonImage = styled.div`
  margin-right: 5px;
  width: 90px;
  height: 90px;
  background-color: #e6e6e6;

  background-image: linear-gradient(90deg, #e6e6e6 8%, #f7f7f7 18%, #e6e6e6 33%);
  background-repeat: no-repeat;
  animation: 1.2s skeletonMove linear infinite;
  background-size: 200% 100%;
`;

const SkeletonLinesWrapper = styled(Col)`
  justify-content: space-between;
  margin-bottom: -5px;
  ${props => props.expand ? `flex: 1 1 0px;` : ``}
`;

const SkeletonLine = styled.div`
  margin-right: 5px;
  margin-bottom: 5px;

  background-color: #e6e6e6;

  background-image: linear-gradient(90deg, #e6e6e6 8%, #f7f7f7 18%, #e6e6e6 33%);
  background-repeat: no-repeat;
  animation: 1.2s skeletonMove linear infinite;
  background-size: 200% 100%;

  ${props => `width: ${props.width}; height: ${props.height};`}
`;

class Skeleton extends React.Component {

  static propTypes = {
    nbCols: PropTypes.number,
    expand: PropTypes.bool
  }

  render = () => {

    const children = [];
    for (let i = 0; i < (this.props.nbCols || 1); i++) {
      children.push((<SkeletonCard expand={this.props.expand}>
        <SkeletonImage></SkeletonImage>
        <SkeletonLinesWrapper expand={this.props.expand}>
          <SkeletonLine width={this.props.expand ? '100%': "100px"} height={"20px"}></SkeletonLine>
          <SkeletonLine width={this.props.expand ? '100%': "100px"} height={"40px"}></SkeletonLine>
          <SkeletonLine width={this.props.expand ? '50%': "50px"} height={"15px"}></SkeletonLine>
        </SkeletonLinesWrapper>
      </SkeletonCard>));

    }


    return (
      <SkeletonWrapper>
        {children.map((child, idx) => <React.Fragment key={idx}>
          {child}
        </React.Fragment>)}
      </SkeletonWrapper>

    );
  }

}
export default Skeleton;
